import ArticlesSidebarSection from '@bridebook/web/app-basic/components/articles/articles-sidebar-section/articles-sidebar-section';
import { getIsTablet } from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { Box } from '@bridebook/ui';
import componentStyles from './sidebar.style';

const Sidebar = () => {
  const isTablet = useSelector(getIsTablet);

  return (
    <Box style={componentStyles({ isTablet }).wrapper}>
      <ArticlesSidebarSection />
    </Box>
  );
};

export default Sidebar;
